import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { ArticleGetters, ArticleState } from '../types'
import { Field } from '@/types/action'
import { ArticleTypeCode } from '@/types/article'
import forOwn from '@/helpers/forOwn'

const articleTypesList: Getter<ArticleState, RootState> = (state) => {
  const getter: ArticleGetters['articleTypesList'] = (params) => {
    const typesMap = new Map<number, Field>()

    forOwn(state.fields.types, (type) => {
      const typeCode = type.caption

      if (
        Array.isArray(params?.includeTypes) &&
        !params?.includeTypes?.some((code) => code === typeCode)
      ) {
        return
      }

      if (
        typesMap.has(type.value) ||
        params?.exludeTypes?.some((code) => code === typeCode)
      ) {
        return
      }

      typesMap.set(
        type.value,
        Object.freeze({
          ...type,
          readonly: typeCode === ArticleTypeCode.NOMINEE,
        })
      )
    })

    return Array.from(typesMap.values())
  }

  return getter
}

export default articleTypesList
